export const GLOBAL_STATE = 'Modules'

export const MODULES = 'modules'
export const MODULES_LIST = 'modulesList'
export const MODULES_ALL = 'modulesAll'
